function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M32.0586 29.0314C34.4132 25.9843 35.8151 22.1565 35.8151 17.9995C35.8151 13.8426 34.4132 10.0149 32.0587 6.96781C32.3885 6.93796 32.7225 6.92271 33.06 6.92271C39.1464 6.92271 44.0804 11.882 44.0804 17.9996C44.0804 24.1172 39.1464 29.0765 33.06 29.0765C32.7225 29.0765 32.3884 29.0613 32.0586 29.0314Z",
  fill: "url(#paint0_linear_23_1259)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M32.058 29.0318C34.4126 25.9847 35.8146 22.1569 35.8146 17.9999C35.8146 13.843 34.4127 10.0153 32.0582 6.96823C26.441 7.4767 22.0391 12.2217 22.0391 18C22.0391 23.7783 26.4409 28.5233 32.058 29.0318Z",
  fill: "url(#paint1_linear_23_1259)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M32.0599 6.96826C26.4427 7.47676 22.0408 12.2217 22.0408 18.0001C22.0408 23.7784 26.4427 28.5233 32.0598 29.0319C28.7835 33.2717 23.6628 36 17.9082 36C8.01776 36 0 27.9411 0 18C0 8.05887 8.01776 0 17.9082 0C23.6629 0 28.7836 2.72832 32.0599 6.96826Z",
  fill: "url(#paint2_linear_23_1259)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M52.3477 6.72899C52.3477 6.0205 52.9198 5.44615 53.6256 5.44615H106.723C107.429 5.44615 108.001 6.0205 108.001 6.72899V29.1787C108.001 29.8872 107.429 30.4615 106.723 30.4615H53.6256C52.9198 30.4615 52.3477 29.8872 52.3477 29.1787V6.72899Z",
  fill: "#FF4F00"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M63.1159 22.3296V10.5839H59.9609V25.266H68.7364V22.3296H63.1159Z",
  fill: "white"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M70.8772 25.266H74.0321V10.5839H70.8772V25.266Z",
  fill: "white"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M86.663 10.5839L83.0692 20.9663L79.371 10.5839H75.8817L81.5858 25.266H84.5736L90.1105 10.5839H86.663Z",
  fill: "white"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M95.2117 22.3296V19.3093H100.289V16.4358H95.2117V13.5203H100.832V10.5839H92.0567V25.266H101.062V22.3296H95.2117Z",
  fill: "white"
});

var _ref10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_23_1259",
  x1: 32.0681,
  y1: 6.92271,
  x2: 32.0681,
  y2: 29.0765,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#5BC2E7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#0078CE"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_23_1259",
  x1: 25.1523,
  y1: 10.4262,
  x2: 32.3518,
  y2: 28.9968,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#9DDAF1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#0078CE"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear_23_1259",
  x1: 6.83266,
  y1: 4.88769,
  x2: 26.8069,
  y2: 33.6198,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FBAC13"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.45223,
  stopColor: "#FF4F00"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF4F00"
})));

var SvgLogoSmall = function SvgLogoSmall(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 36,
    viewBox: "0 0 108 36",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogoSmall, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo_small.c1a5de57.svg";
export { ForwardRef as ReactComponent };